import { POLONIA_CREST as logoUrl } from './clubIdentity';
import { useState } from 'react';
import { getSupabase } from './supabase';
import { useI18n } from './I18nContext';
import { LoadingCrest } from './LoadingCrest';

export function LoginScreen({ onLogin }: { onLogin: () => void }) {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    const client = getSupabase();
    if (!client) return;
    setMessage('');
    setSubmitting(true);
    const { error } = await client.auth.signInWithPassword({ email, password });
    setSubmitting(false);
    if (error) {
      setMessage(error.message);
      return;
    }
    onLogin();
  }

  return (
    <>
      {submitting && <LoadingCrest />}
      <div className="auth-stage">
      <section className="metal-card auth-card">
        <img className="auth-logo" src={logoUrl} alt="" />
        <p className="eyebrow">POLONIA GLASGOW AFC</p>
        <h1>{t.loginTitle}</h1>
        <label>{t.email}</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
        <label>{t.password}</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
        <button onClick={submit}>{t.login}</button>
        {message && <p className="error-text">{message}</p>}
      </section>
      </div>
    </>
  );
}
